import React, {
  forwardRef,
  useState,
  useMemo,
  useCallback,
  useEffect,
} from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes } from "utils/formUtils";
import message from "components/CustomMessage";
import GenericMappingForm from "../GenericMappingForm";
import { split } from "utils/lodashUtils";
import { Form } from "antd";

const AppcheckMappingForm = forwardRef(function AppcheckMappingForm(
  { disableProjectFields, ...props },
  ref
) {
  const [form] = Form.useForm();
  const [scanList, setScanList] = useState(() => {
    if (props.record) {
      const { scanId, scanName } = props.record;
      const scanIdArray = scanId.split(",");
      const scanNameArray = scanName.split(",");
      return scanIdArray.map((id, index) => ({
        id,
        name: scanNameArray[index],
      }));
    }
    return [];
  });
  const [loading, setLoading] = useState(true);

  const fetchScans = useCallback(
    (params) => {
      const { promise, cancel } =
        ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {
          login_id: props.loginConfigId,
          ...params,
        });
      promise
        .then((response) => {
          const { projects } = response;
          setScanList(projects);
        })
        .catch(() => {
          message.error("Problem fetching scans");
        })
        .finally(() => setLoading(false));

      return { promise, cancel };
    },
    [props.loginConfigId, props.toolName]
  );

  useEffect(() => fetchScans(), [fetchScans]);

  const getExtraFieldsData = (config) => {
    const { scanId } = config;
    const data = scanList.reduce(
      (acc, cv) => {
        const { id, name } = cv;
        if (scanId.includes(id)) {
          acc.id.push(id);
          acc.name.push(name);
        }
        return acc;
      },
      { id: [], name: [] }
    );
    return {
      scanId: data.id.join(),
      scanName: data.name.join(),
      //send the property received in config
      ...(config.discovery_config_id && {
        discovery_config_id: config.discovery_config_id,
      }),
    };
  };

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { scanId } = config;
    return {
      scanId: split(scanId, ","),
      //send the property received in config
      ...(config.discovery_config_id && {
        discovery_config_id: config.discovery_config_id,
      }),
    };
  }, []);

  const extraFields = useMemo(
    () => [
      {
        name: "scanId",
        colSpan: 12,
        type: FieldTypes.MULTI_SELECT,
        loading,
        label: "Scan Name",
        options: scanList,
        disabled: disableProjectFields,
        required: true,
        props: {
          autoFocus: !disableProjectFields,
        },
      },
    ],
    [scanList, disableProjectFields, loading]
  );

  return (
    <GenericMappingForm
      ref={ref}
      form={form}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={extraFields}
      {...props}
    />
  );
});

export default AppcheckMappingForm;
